<template>
  <div>
    <div class="card shadow">
      <div class="card-header">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'users' }">Users</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              User Details
            </li>
          </ol>
        </nav>
      </div>
      <div class="card-body">
        <dl class="row">
          <dt class="col-3">
            Name
          </dt>
          <dd class="col-9">
            {{ user.name }} <span class="badge badge-pill badge-light">{{ user.country }}</span>
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-3">
            Username
          </dt>
          <dd class="col-9">
            <a :href="`https://www.nyonyacooking.com/${ user.username }`" target="_blank">@{{ user.username }}</a>
            <span v-if="user.public" class="badge badge-pill badge-success">Public</span>
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-3">
            Email address
          </dt>
          <dd class="col-9">
            {{ user.email }}
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-3">
            Stripe Customer ID
          </dt>
          <dd class="col-9">
            {{ user.stripe_id }}
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-3">
            Bio
          </dt>
          <dd class="col-9">
            {{ user.bio }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      user: {},
    }
  },

  mounted() {
    this.getUser()
  },

  methods: {
    async getUser() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/users/${ this.$route.params.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.user = data
    },
  },
}
</script>
